import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { authService } from '@/services/auth';
import { useAuthStore } from '@/context/authStore';

/**
 * Mantiene el usuario del store (persistido en localStorage) sincronizado con el backend.
 *
 * Sin esto los permisos quedan congelados en los que tenía al momento de loguearse: si el
 * admin le agrega "Inventario", el usuario sigue viendo "no tenés permiso" hasta cerrar
 * sesión y volver a entrar. Mismo criterio que useEnsureTenant con los flags de la vete.
 *
 * En impersonación no se toca: el usuario del store es el superadmin y el token es de otro.
 */
export function useSyncCurrentUser() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const isImpersonating = useAuthStore((s) => s.impersonation.isImpersonating);
  const updateUser = useAuthStore((s) => s.updateUser);

  const { data } = useQuery({
    queryKey: ['auth-me'],
    queryFn: authService.getCurrentUser,
    enabled: isAuthenticated && !isImpersonating,
    refetchOnWindowFocus: true,
    staleTime: 30_000,
  });

  useEffect(() => {
    if (data) updateUser(data);
  }, [data, updateUser]);
}
